module.exports = __webpack_public_path__ + "img/vip-green-line.88d491b7.png";